import React from "react"
import {Row, Col} from "@irati/ui/src/Layout"
import {Product, BasketTotalWithBreakDown} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"

interface Props {
  data: Product[]
  breakdown: BasketTotalWithBreakDown
  displayFlexiPoints?: boolean
  flexiPointsNumber?: number
}

const ProductList: React.FC<Props> = ({data, breakdown, displayFlexiPoints, flexiPointsNumber}) => {
  const products = breakdown.items.map((breakdownItem) => {
    return {
      ...breakdownItem,
      item: {
        ...breakdownItem.item,
        product: data.find((product) => product.uuid === breakdownItem.item.productId)!
      }
    }
  })

  return (
    <div className="orderSummaryProductList">
      {data.length > 0 && (
        <>
          {products.map(({item, total}) => (
            <div className="orderSummaryProductList__item" style={{margin: "1px"}} key={item.productId}>
              <Row>
                <Col xs={2}>
                  <Body small weight="bold" color="ink">
                    {item.count || 1}x
                  </Body>
                </Col>
                <Col xs={6}>
                  <Body small weight="bold" color="ink">
                    {item.product.name}
                  </Body>
                </Col>
                <Col xs={4}>
                  <div className="pull-right">
                    <Body small weight="bold" color="ink">
                      {total.originalPrice > 0 && <FormattedCurrency value={total.originalPrice} currency={total.currency} />}
                      {!total.originalPrice && <FormattedMessage id="perks.components.orderSummary.getTotal.free" />}
                    </Body>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
          {displayFlexiPoints && (
            <Row style={{marginTop: 1}}>
              <Col xs={2}>
                <Body small weight="bold" color="ink">
                  {flexiPointsNumber}
                </Body>
              </Col>
              <Col xs={6}>
                <Body small weight="bold" color="ink">
                  <FormattedMessage id="perks.components.saving.label.flexiPoints" />
                </Body>
              </Col>
            </Row>
          )}
        </>
      )}
      {data.length > 0 && <hr />}
    </div>
  )
}

export default ProductList
